import {http} from '@/http/index.js';

async function createVerificationAttempt(girlId, formData) {
  return http
    .post(`/girls/${girlId}/verifications`, formData)
    .then((response) => response.data);
}

export {createVerificationAttempt};
